<template>
  <el-dialog title="添加/编辑设备"
    :visible.sync="$parent.carryOutCom"
    width="40%">
    <el-form :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
      style="width: 80%">
      <el-form-item label="保养计划名称"
        prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="设备名称">
        <p>{{clickItem.name}}</p>
      </el-form-item>
      <el-form-item label="选择日期"
        prop="date">
        <el-date-picker type="date"
          placeholder="选择日期"
          v-model="ruleForm.date"
          value-format="timestamp"
          style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="保养人员"
        prop="user">
        <el-select v-model="ruleForm.user"
          filterable
          placeholder="请选择保养人员"
          multiple
          collapse-tags
          style="width:100%">
          <el-option v-for="item in userList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="保养内容"
        prop="desc">
        <el-input type="textarea"
          v-model="ruleForm.desc"
          resize="none"
          rows="3"
          maxlength="20"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.carryOutCom = false">取 消</el-button>
      <el-button type="primary"
        @click="submitForm('ruleForm')"
        :loadin="btnLoading">确 定</el-button>
    </span>
  </el-dialog>

</template>

<script>
import api from "@/api";
export default {
  props: {
    clickItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        name: "",
        desc: "",
        date: "",
        user: [],
      },
      rules: {
        name: [
          { required: true, message: "请填写名称" },
          { whitespace: true, message: "名称不能为空" },
        ],
        desc: [
          { required: true, message: "请填写保养内容" },
          { whitespace: true, message: "保养内容不能为空" },
          { min: 1, max: 20, message: "请输入不超过 20 个字", trigger: "blur" },
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        user: [{ required: true, message: "请选择保养人员" }],
      },
      userList: [],
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return new Promise(async (resolve) => {
            console.log(this.ruleForm);
            this.btnLoading = true;
            let handlersInfo = [];
            this.ruleForm.user.map((v) => {
              handlersInfo.push({ id: v });
            });
            let res = await api.maintenanceInfoHandle({
              id: {
                entityType: "INSPECTION_POINT",
                id: this.clickItem.id,
              },
              staffInfos: handlersInfo,
              name: this.ruleForm.name,
              maintenanceTime: this.ruleForm.date,
              maintenanceContent: this.ruleForm.desc,
            });
            if (res && res.data.code == 200) {
              this.$message.success("操作成功");
              this.$store.commit("SET_LOADING", true);
              this.$parent.carryOutCom = false;
              setTimeout(() => {
                this.$parent.getList();
              }, 1000);
            } else if (res && res.data.code == "00003") {
              this.btnLoading = false;
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
    async getUserList() {
      let res = await api.projectGetUserListByPower({
        permission: "houqinguanli:baoyangguanli:equipmentMaintain:edit",
      });
      if (res && res.data.code == 200) {
        this.userList = res.data.data;
      }
    },
  },
  created() {
    this.getUserList();
  },
};
</script>

<style>
</style>